import { combineReducers } from "redux"
import { impersonate } from './impersonateReducer'

const impersonateReducers = combineReducers({
    impersonate,
})

export default impersonateReducers